import React from 'react'
import {Button, DialogActions} from '@mui/material'

export default function DialogCancelConfirm(props: DialogCancelConfirmProps) {
    const {
        cancel,
        confirm,
        cancelId,
        cancelText,
        confirmId,
        confirmText,
        cancelDisabled,
        confirmDisabled,
        showOnlyConfirm
    } = props

    return (
        <DialogActions>
            {!showOnlyConfirm && (
                <Button disabled={cancelDisabled} id={cancelId} onClick={cancel}>
                    {cancelText || 'Cancel'}
                </Button>
            )}
            <Button disabled={confirmDisabled} id={confirmId} data-cy={confirmId} onClick={confirm} color="primary">
                {confirmText || 'Confirm'}
            </Button>
        </DialogActions>
    )
}

export interface DialogCancelConfirmProps {
    cancel: () => void
    confirm: () => void
    cancelId?: string
    cancelText?: string
    confirmId?: string
    confirmText?: string
    cancelDisabled?: boolean
    confirmDisabled?: boolean
    showOnlyConfirm?: boolean
}
